export const tableschema4 = {
    "name_table": "Розділ IV. Кількість працівників закладу на кінець звітного року",
    "titles": [
        "Усього у тому числі",
        "Педагогічні працівники з них",
        "керівники закладів дошкільної освіти (директори, завідувачі)",
        "заступники керівників закладів дошкільної освіти з організації освітнього процесу (директорів, завідувачів)",
        "керівники (завідувачі) дошкільних підрозділів",
        "завідувачі філії",
        "вихователі-методисти",
        "вихователі",
        "асистенти вихователів",
        "вчителі англійської мови",
        "вчителі-дефектологи",
        "в тому числі",
        "сурдопедагоги",
        "корекційні педагоги",
        "тифлопедагоги",
        "вчителі-реабілітологи",
        "практичні психологи",
        "соціальні педагоги",
        "інструктори з фізичної культури",
        "інструктори слухових кабінетів",
        "музичні керівники",
        "керівники гуртків, студій, секцій тощо",
        "інші педагогічні працівники",
        "медичні працівники",
        "технічний працівники",
        "жінки",
        "працюють з дітьми до 3 років",
        "працюють з дітьми старше 3 років",
        "Мають педагогічне навантаження менше норми",
        "Підвищили кваліфікацію з підтримки дітей з ООП"
    ],
    "parts": [
        {
            "title": "Облікова кількість штатних, осіб",
            "subtitle": "усього",
            "fields": [
                "PR3001",
                "PR3101",
                "PR3111",
                "PR41",
                "PR51",
                "PR61",
                "PR3131",
                "",
                "PR9061",
                "PR101",
                "PR111",
                "PR31521",
                "PR31551",
                "PR141",
                "PR31531",
                "PR161",
                "PR3141",
                "PR3151",
                "PR31071",
                "PR201",
                "PR31081",
                "PR31091",
                "PR3161",
                "PR3201",
                "PR3301",
                "PR271",
                "PR281",
                "PR291",
                "PR301",
                "PR3501"
            ]
        },
        {
            "title": "",
            "subtitle": "з них жінки",
            "fields": [
                "PR3002",
                "PR3102",
                "PR3112",
                "PR42",
                "PR52",
                "PR62",
                "PR3132",
                "PR3122",
                "PR9062",
                "PR102",
                "PR112",
                "PR31522",
                "PR31552",
                "PR142",
                "PR31532",
                "PR162",
                "PR3142",
                "PR3152",
                "PR31072",
                "PR202",
                "PR31082",
                "PR31092",
                "PR3162",
                "PR3202",
                "PR3302",
                "PR272",
                "PR282",
                "PR292",
                "PR302",
                "PR3502"
            ]
        },
        {
            "title": "Особи у віці",
            "subtitle": "менше 25",
            "fields": [
                "PR13",
                "PR23",
                "PR33",
                "PR43",
                "PR53",
                "PR63",
                "PR73",
                "PR83",
                "PR93",
                "PR103",
                "PR113",
                "PR123",
                "PR133",
                "PR143",
                "PR153",
                "PR163",
                "PR173",
                "PR183",
                "PR193",
                "PR203",
                "PR213",
                "PR223",
                "PR233",
                "PR243",
                "PR253",
                "PR273",
                "PR283",
                "PR293",
                "PR303",
                "PR313"
            ]
        },
        {
            "title": "",
            "subtitle": "25-29",
            "fields": [
                "PR14",
                "PR24",
                "PR34",
                "PR44",
                "PR54",
                "PR64",
                "PR74",
                "PR84",
                "PR94",
                "PR104",
                "PR114",
                "PR124",
                "PR134",
                "PR144",
                "PR154",
                "PR164",
                "PR174",
                "PR184",
                "PR194",
                "PR204",
                "PR214",
                "PR224",
                "PR234",
                "PR244",
                "PR254",
                "PR274",
                "PR284",
                "PR294",
                "PR304",
                "PR314"
            ]
        },
        {
            "title": "",
            "subtitle": "30-34",
            "fields": [
                "PR15",
                "PR25",
                "PR35",
                "PR45",
                "PR55",
                "PR65",
                "PR75",
                "PR85",
                "PR95",
                "PR105",
                "PR115",
                "PR125",
                "PR135",
                "PR145",
                "PR155",
                "PR165",
                "PR175",
                "PR185",
                "PR195",
                "PR205",
                "PR215",
                "PR225",
                "PR235",
                "PR245",
                "PR255",
                "PR275",
                "PR285",
                "PR295",
                "PR305",
                "PR315"
            ]
        },
        {
            "title": "",
            "subtitle": "35-39",
            "fields": [
                "PR16",
                "PR26",
                "PR36",
                "PR46",
                "PR56",
                "PR66",
                "PR76",
                "PR86",
                "PR96",
                "PR106",
                "PR116",
                "PR126",
                "PR136",
                "PR146",
                "PR156",
                "PR166",
                "PR176",
                "PR186",
                "PR196",
                "PR206",
                "PR216",
                "PR226",
                "PR236",
                "PR246",
                "PR256",
                "PR276",
                "PR286",
                "PR296",
                "PR306",
                "PR316"
            ]
        },
        {
            "title": "",
            "subtitle": "40-44",
            "fields": [
                "PR17",
                "PR27",
                "PR37",
                "PR47",
                "PR57",
                "PR67",
                "PR77",
                "PR87",
                "PR97",
                "PR107",
                "PR117",
                "PR127",
                "PR137",
                "PR147",
                "PR157",
                "PR167",
                "PR177",
                "PR187",
                "PR197",
                "PR207",
                "PR217",
                "PR227",
                "PR237",
                "PR247",
                "PR257",
                "PR277",
                "PR287",
                "PR297",
                "PR307",
                "PR317"
            ]
        },
        {
            "title": "",
            "subtitle": "45-49",
            "fields": [
                "PR18",
                "PR28",
                "PR38",
                "PR48",
                "PR58",
                "PR68",
                "PR78",
                "PR88",
                "PR98",
                "PR108",
                "PR118",
                "PR128",
                "PR138",
                "PR148",
                "PR158",
                "PR168",
                "PR178",
                "PR188",
                "PR198",
                "PR208",
                "PR218",
                "PR228",
                "PR238",
                "PR248",
                "PR258",
                "PR278",
                "PR288",
                "PR298",
                "PR308",
                "PR318"
            ]
        },
        {
            "title": "",
            "subtitle": "50-54",
            "fields": [
                "PR19",
                "PR29",
                "PR39",
                "PR49",
                "PR59",
                "PR69",
                "PR79",
                "PR89",
                "PR99",
                "PR109",
                "PR119",
                "PR129",
                "PR139",
                "PR149",
                "PR159",
                "PR169",
                "PR179",
                "PR189",
                "PR199",
                "PR209",
                "PR219",
                "PR229",
                "PR239",
                "PR249",
                "PR259",
                "PR279",
                "PR289",
                "PR299",
                "PR309",
                "PR319"
            ]
        },
        {
            "title": "",
            "subtitle": "55-59",
            "fields": [
                "PR110",
                "PR210",
                "PR310",
                "PR410",
                "PR510",
                "PR610",
                "PR710",
                "PR810",
                "PR910",
                "PR1010",
                "PR1110",
                "PR1210",
                "PR1310",
                "PR1410",
                "PR1510",
                "PR1610",
                "PR1710",
                "PR1810",
                "PR1910",
                "PR2010",
                "PR2110",
                "PR2210",
                "PR2310",
                "PR2410",
                "PR2510",
                "PR2710",
                "PR2810",
                "PR2910",
                "PR3010",
                "PR31101"
            ]
        },
        {
            "title": "",
            "subtitle": "60-64",
            "fields": [
                "PR11165",
                "PR211",
                "PR311",
                "PR411",
                "PR511",
                "PR611",
                "PR711",
                "PR811",
                "PR911",
                "PR1011",
                "PR1111",
                "PR1211",
                "PR1311",
                "PR1411",
                "PR1511",
                "PR1611",
                "PR1711",
                "PR1811",
                "PR1911",
                "PR2011",
                "PR2111",
                "PR2211",
                "PR2311",
                "PR2411",
                "PR2511",
                "PR2711",
                "PR2811",
                "PR2911",
                "PR3011",
                "PR31111"
            ]
        },
        {
            "title": "",
            "subtitle": "65 і більше",
            "fields": [
                "PR11265",
                "PR212",
                "PR312",
                "PR412",
                "PR512",
                "PR612",
                "PR712",
                "PR812",
                "PR912",
                "PR1012",
                "PR1112",
                "PR1212",
                "PR1312",
                "PR1412",
                "PR1512",
                "PR1612",
                "PR1712",
                "PR1812",
                "PR1912",
                "PR2012",
                "PR2112",
                "PR2212",
                "PR2312",
                "PR2412",
                "PR2512",
                "PR2712",
                "PR2812",
                "PR2912",
                "PR3012",
                "PR31121"
            ]
        },
        {
            "title": "Освіта",
            "subtitle": "фаховий мол. бакалавр",
            "fields": [
                "PR113E",
                "PR213E",
                "PR313E",
                "PR413",
                "PR513",
                "PR613",
                "PR713",
                "PR813",
                "PR913",
                "PR1013",
                "PR1113",
                "PR1213",
                "PR1313",
                "PR1413",
                "PR1513",
                "PR1613",
                "PR1713",
                "PR1813",
                "PR1913",
                "PR2013",
                "PR2113",
                "PR2213",
                "PR2313",
                "PR2413",
                "PR2513",
                "PR2713",
                "PR2813",
                "PR2913",
                "PR3013",
                "PR3113"
            ]
        },
        {
            "title": "",
            "subtitle": "мол. бакалавр (мол. спец)",
            "fields": [
                "PR114E",
                "PR214E",
                "PR314E",
                "PR414",
                "PR514",
                "PR614",
                "PR714",
                "PR814",
                "PR914",
                "PR1014",
                "PR1114",
                "PR1214",
                "PR1314",
                "PR1414",
                "PR1514",
                "PR1614",
                "PR1714",
                "PR1814",
                "PR1914",
                "PR2014",
                "PR2114",
                "PR2214",
                "PR2314",
                "PR2414",
                "PR2514",
                "PR2714",
                "PR2814",
                "PR2914",
                "PR3014",
                "PR3114"
            ]
        },
        {
            "title": "",
            "subtitle": "бакалавр",
            "fields": [
                "PR115E",
                "PR215E",
                "PR315E",
                "PR415",
                "PR515",
                "PR615",
                "PR715",
                "PR815",
                "PR915",
                "PR1015",
                "PR1115",
                "PR1215",
                "PR1315",
                "PR1415",
                "PR1515",
                "PR1615",
                "PR1715",
                "PR1815",
                "PR1915",
                "PR2015",
                "PR2115",
                "PR2215",
                "PR2315",
                "PR2415",
                "PR2515",
                "PR2715",
                "PR2815",
                "PR2915",
                "PR3015",
                "PR31151"
            ]
        },
        {
            "title": "",
            "subtitle": "магістр (спец)",
            "fields": [
                "PR116E",
                "PR216E",
                "PR316E",
                "PR416",
                "PR516",
                "PR616",
                "PR716",
                "PR816",
                "PR916",
                "PR1016",
                "PR1116",
                "PR1216",
                "PR1316",
                "PR1416",
                "PR1516",
                "PR1616",
                "PR1716",
                "PR1816",
                "PR1916",
                "PR2016",
                "PR2116",
                "PR2216",
                "PR2316",
                "PR2416",
                "PR2516",
                "PR2716",
                "PR2816",
                "PR2916",
                "PR3016",
                "PR31161"
            ]
        },
        {
            "title": "Кількість посад",
            "subtitle": "за штатним розписом",
            "fields": [
                "PR3007",
                "PR3107",
                "PR3117",
                "PR417",
                "PR517",
                "PR617",
                "PR717",
                "PR817",
                "PR917",
                "PR1017",
                "PR1117",
                "PR1217",
                "PR1317",
                "PR1417",
                "PR1517",
                "PR1617",
                "PR1717",
                "PR1817",
                "PR1917",
                "PR2017",
                "PR2117",
                "PR2217",
                "PR2317",
                "PR2417",
                "PR2517",
                "PR2717",
                "PR2817",
                "PR2917",
                "PR3017",
                "PR31171"
            ]
        },
        {
            "title": "",
            "subtitle": "фактично зайнятих",
            "fields": [
                "PR3008",
                "PR3108",
                "PR3118",
                "PR418",
                "PR518",
                "PR618",
                "PR718",
                "PR818",
                "PR918",
                "PR1018",
                "PR1118",
                "PR1218",
                "PR1318",
                "PR1418",
                "PR1518",
                "PR1618",
                "PR1718",
                "PR1818",
                "PR1918",
                "PR2018",
                "PR2118",
                "PR2218",
                "PR2318",
                "PR2418",
                "PR2518",
                "PR2718",
                "PR2818",
                "PR2918",
                "PR3018",
                "PR31181"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "27",
            "28",
            "29",
            "30",
            "31"
        ],
        "parts": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18"
        ]
    }
};